import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { CompanyComment, HttpResponse } from "@/types";

export function useDeleteCompanyComment() {
  const currentCompanyId = useCurrentCompanyId();

  const mutation = useMutation({
    mutationFn: async ({ companyCommentId }: { companyCommentId: number }) => {
      const path = `companies/${currentCompanyId}/company-comments/${companyCommentId.toString()}`;
      const res = await guacHttpClient.delete<
        CompanyComment,
        HttpResponse<CompanyComment>
      >(path);

      return res.data;
    },
  });

  return mutation;
}
